var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full -mt-10"},[_c('div',{staticClass:"flex items-center justify-end mr-10 pb-2"},[_c('img',{attrs:{"src":_vm.companyUrl}})])])}
var staticRenderFns = []

export { render, staticRenderFns }